import React, { useState, useMemo, useCallback } from "react";
import { useMutation } from "react-query";
import notify from "utils/notify";

import PageTitle from "../common/PageTitle";
import BillLogo from "./shared/BillLogo";
// import PayBillsJawwalModal from "./PayBillsJawwalModal";

import {
  getJawwalBillsApiCalled,
  payJawwalBillApiCalled,
} from "shared/endPoints/apiCallers";

import NoBalanceCard from "components/cards/NoBalanceCard";
import translate from "i18n/translate";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import EditableTextFieldForm from "./shared/InputBills";
import DataTable from "./shared/DataTable";
import { calcTotalAmount } from "./shared/calcTotalAmount";
import GeneralPayModal from "./shared/GeneralPayModal";
import { Button, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const JawwalBills = () => {
  const [number, setNumber] = useState("");
  const [identity, setIdentity] = useState("");
  const [selectedBill, setSelectedBill] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [jawwalPills, setJawwalPills] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const { state } = history.location;
    if (state?.number) {
      setNumber(state.number);
      setIdentity(state.identity);
      getJawwalBills({ id: state.identity, number: state.number });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const {
  //   mutate: verifyJawwalNumber,
  //   data: isIdentityNeeded,
  //   isSuccess,
  // } = useMutation(verifyJawwalNumberApiCalled);
  const {
    isLoading,
    mutate: getJawwalBills,
    data: pills,
    reset,
  } = useMutation(getJawwalBillsApiCalled, {
    onSuccess: (res) => {
      if (res?.status === "failed") {
        const errorReason = res?.reason ?? "Something went wrong";
        setErrorMessage(errorReason);
        return;
      }
    },
    onError: () => {
      notify.failure(`Something went wrong !`);
    },
  });

  useEffect(() => {
    if (pills?.length > 0) {
      setJawwalPills(
        pills.reverse().map((pill) => ({
          ...pill,
          date: pill.date1,
        }))
      );
    }
  }, [pills]);
  const onSubmit = useCallback(async (value) => {
    if (!value || value.trim() === '') {
      setErrorMessage("Please enter a valid phone number");
      return;
    }

    // Validate phone number - must be exactly 10 digits
    const cleanedNumber = value.replace(/\D/g, ''); // Remove non-digits
    if (cleanedNumber.length !== 10) {
      setErrorMessage("Phone number must be exactly 10 digits");
      notify.failure("Phone number must be exactly 10 digits");
      return;
    }

    setNumber(value);
    setSelectedBill([]);
    setJawwalPills([]);
    setErrorMessage("");

    try {
      await getJawwalBills({ id: identity, number: cleanedNumber });
    } catch (error) {
      setErrorMessage("Failed to fetch bills. Please try again.");
    }
  }, [identity, getJawwalBills]);

  const clearSelections = useCallback(() => {
    setSelectedBill([]);
    reset();
  }, [reset]);

  const totalAmount = useMemo(() =>
    parseFloat(calcTotalAmount(selectedBill).toFixed(2)),
    [selectedBill]
  );

  const handlePaymentSuccess = useCallback(() => {
    // Payment success handled by modal, no additional notification needed
  }, [selectedBill.length]);

  return (
    <div>
      <PageTitle title={translate("Jawwal Bills")} backPage="/pay_bills">
        <BillLogo
          src="https://cdnjobs.net/cached_uploads/full/2020/02/16/jawwal-1581878215.png"
          alt="jawwal"
          style={{ marginTop: 20 }}
        />
        <EditableTextFieldForm
          initialValue={number}
          label={translate("Phone number")}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
        {jawwalPills?.length > 0 && (
          <>
            <div className="d-flex align-items-center justify-content-between mt-4">
              <p>
                {translate("Total Bills Amount")}:{" "}
                <span className="text-info">
                  {totalAmount} {translate("ILS")}
                </span>
              </p>
              {/* <PayBillsJawwalModal
                selectedBill={selectedBill}
                number={number}
                isDisabled={!totalAmount || isLoading}
                clearSelections={clearSelections}
                totalAmount={totalAmount}
              /> */}
              <GeneralPayModal
                selectedBill={selectedBill}
                number={number}
                isDisabled={!totalAmount || isLoading}
                clearSelections={clearSelections}
                totalAmount={totalAmount}
                apiCall={payJawwalBillApiCalled}
                identity={identity}
                provider="jawwal"
                onSubmitSuccess={handlePaymentSuccess}
              />
            </div>
            <DataTable
              rows={jawwalPills}
              isLoading={isLoading}
              onRowSelect={setSelectedBill}
              selectedRows={selectedBill}
              onAmountChange={(row, amount) => {
                setJawwalPills((prev) =>
                  prev.map((item) =>
                    item.id === row.id ? { ...item, amount } : item
                  )
                );
              }}
            />
          </>
        )}
        {pills?.length === 0 && <h5>{translate("No Results Found")}</h5>}
        {errorMessage && <h5 className="text-danger">{errorMessage}</h5>}

        <Box sx={{ display: 'flex', marginTop: 4, marginBottom: 2 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/pay_bills")}
            sx={{ minWidth: 120 }}
          >
            {translate("Back")}
          </Button>
        </Box>
      </PageTitle>
    </div>
  );
};

export default JawwalBills;
